<template>
  <div class="marketing-sms-form-send">
    <div class="marketing-sms-form-send-body">
      <v-radio-group v-validate="'required'"
                     :value="value.scheduleType"
                     :error-messages="errors.collect($t('message.marketingGenerics.message.send'))"
                     :disabled="viewOnly"
                     name="Envio"
                     class="marketing-sms-form-send-body"
                     @change="emitVal">

        <v-radio :label="$t('message.marketingGenerics.message.sendNow')"
                 value="NOW"></v-radio>

        <v-radio :label="$t('message.marketingGenerics.message.schedule')"
                 value="SCHEDULE"></v-radio>

      </v-radio-group>

      <div v-if="isScheduled"
           class="marketing-sms-form-send-body-schedule">
        <app-box-wrapper data-icon="mdi-calendar-multiselect">
          <app-date-picker class="marketing-sms-form-send-body-schedule-date"
                           :value="value.schedule.date"
                           :disabled="viewOnly"
                           @input="emitInput('date', $event)"></app-date-picker>
        </app-box-wrapper>

        <span>{{$t('message.marketingGenerics.message.at')}}</span>

        <app-box-wrapper data-icon="mdi-clock-outline">
          <app-hour-picker :value="value.schedule.hour"
                           :readonly="viewOnly"
                           :datalabel="$t('message.marketingGenerics.message.scheduleTime')"
                           class="hour"
                           center
                           @input="emitInput('hour', $event)"></app-hour-picker>
        </app-box-wrapper>
      </div>
      <p v-if="isScheduled"
         class="marketing-sms-form-send-body-alert"><span class="bold">{{$t('message.marketingGenerics.message.warning')}}</span> {{$t('message.marketingGenerics.message.warningRecipientsList')}}</p>
    </div>
  </div>
</template>

<script>
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import AppHourPicker from "@components/HourPicker";
import { cloneDeep } from "lodash";

export default {
  components: {
    AppBoxWrapper,
    AppDatePicker,
    AppHourPicker,
  },

  data() {
    return {};
  },

  props: {
    value: {
      type: Object,
      default() {
        return {
          schedule: {
            date: undefined,
            hour: undefined,
          },
          scheduleType: "NOW",
        };
      },
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    emitInput(key, val) {
      const value = cloneDeep(this.value);

      value.schedule[key] = val;

      this.$emit("input", value);
    },
    emitVal(val) {
      if (val === "NOW") {
        this.$emit("input", {
          schedule: {
            date: undefined,
            hour: undefined,
          },
          scheduleType: "NOW",
        });
      } else {
        this.$emit("input", {
          schedule: {
            date: this.value.date,
            hour: this.value.hour,
          },
          scheduleType: val,
        });
      }
    },
  },

  created() {},

  computed: {
    isScheduled() {
      return this.value.scheduleType === "SCHEDULE";
    },
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
.marketing-sms-form-send {
  .marketing-sms-form-send-body {
    margin: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .marketing-sms-form-send-body-schedule {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 10px;

      .marketing-sms-form-send-body-schedule-date {
        flex: 1;
      }

      .box {
        margin: 0;
        flex: 0;
      }

      span {
        margin: 0 15px;
      }
    }

    .marketing-sms-form-send-body-alert {
      font-size: 14px;
      margin: 0;

      .bold {
        font-weight: 600;
      }
    }
  }
}
</style>
